'use strict';
const angular = require('angular');
const {copy} = angular;

module.exports = function () {
  return {
    $get: [
      '$injector',
      function ($injector) {
        function archivableProperty(Class, domainClassName, propertyName, linkField) {
          var capitalizedName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
          var currentValue = 'current' + capitalizedName;
          var updateMethod = 'update' + capitalizedName;
          var archiveMethod = 'archive' + capitalizedName;

          // TODO: consider converting to a nested document with minimal metadata
          Class.$constraints.addConstraint(currentValue, {
            type: 'Domain',
            domainClass: domainClassName,
            defaultValue: generateDefaultValue
          });

          Class.$constraints.addConstraint(propertyName + 'History', {
            type: 'DomainCollection',
            domainClass: domainClassName,
            link: linkField,
            belongsTo: true
          });

          Class.$doAfterSave(doAfterSave);

          // Prototype Methods

          // This method is largely for semantic clarity. It also checks that a new value is being assigned, which could aid in earlier bug detection.
          Class.prototype[updateMethod] = function (newValue) {
            if (typeof newValue === 'undefined') {
              throw new Error('You called ' + updateMethod + ' without a ' + propertyName + '!');
            }
            return this[archiveMethod](newValue);
          };

          Class.prototype[archiveMethod] = function (newValue) {
            var self = this;
            if (self[currentValue]) {
              var current = self[currentValue];
              self[currentValue] = null;
              current.isArchived = true;

              var saveCurrentPromise = current.$save();
              var archivePromise = self['$addTo' + capitalizedName + 'History'](current);
              var assignPromise = assign.call(self, newValue);

              return Promise.all([saveCurrentPromise, archivePromise, assignPromise]);
            } else if (typeof newValue !== 'undefined') {
              return assign.call(self, newValue);
            } else {
              return Promise.resolve(null);
            }
          };


          function assign(newValue) {
            var self = this;
            var newValuePromise;
            var savePromise;
            newValue = newValue || self.$constraints[currentValue].domainClass.$factory.create();
            newValue[linkField] = this;

            if (!newValue.$isPersisted()) {
              newValuePromise = newValue.$save();
            }

            self[currentValue] = newValue;
            savePromise = self.$save().catch(function (errors) {
              console.warn('failed to save ' + linkField + ' with id "' + self.$id + '"', copy(self), errors);
            });

            return Promise.all([newValuePromise, savePromise]);
          }

          function generateDefaultValue() {
            var domainClass = $injector.get(domainClassName);
            return domainClass.$factory.create();
          }

          function doAfterSave(instance) {
            instance[currentValue][linkField] = instance;

            if (instance[currentValue] && !instance[currentValue].$isPersisted()) {
              return instance[currentValue].$save();
            }
          }
        }

        return archivableProperty;
      }]
  }
};


// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/ArchivableMixin.js